/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react'
import { Html, Line } from '@react-three/drei'
import { const_var, params } from '../../../../../../../redux/reducers/reducer'

const OutLineSection = () => {
    const freeSpace = 0.2;

    const camPosZ = const_var.camera?.position?.z;
    let offset = 1
    if(camPosZ >= 0) offset = 1;
    else if(camPosZ < 0) offset = -1;

    const leftLinePoints = useMemo(() => (
        [
            [params.p_w / 2 - freeSpace, 0.15, -params.leanR_p_w / 2 - freeSpace * 2],
            [params.p_w / 2 - freeSpace, 0.15, params.leanR_p_w / 2 + freeSpace],
            [params.p_w / 2 - freeSpace, params.leanR_p_h - freeSpace, params.leanR_p_w / 2 + freeSpace],
            [params.p_w / 2 - freeSpace, params.leanR_p_h - freeSpace, -params.leanR_p_w / 2 - freeSpace * 2],
            [params.p_w / 2 - freeSpace, 0.15, -params.leanR_p_w / 2 - freeSpace * 2],
        ]
    ), [params.p_w, params.leanR_p_w, params.leanR_p_h])

    const rightLinePoints = useMemo(() => (
        [
            [params.p_w / 2 + parseInt(params.add_storage_right) + freeSpace, 0.15, -params.leanR_p_w / 2 - freeSpace * 2],
            [params.p_w / 2 + parseInt(params.add_storage_right) + freeSpace, 0.15, params.leanR_p_w / 2 + freeSpace],
            [params.p_w / 2 + parseInt(params.add_storage_right) + freeSpace, params.leanR_p_h - freeSpace, params.leanR_p_w / 2 + freeSpace],
            [params.p_w / 2 + parseInt(params.add_storage_right) + freeSpace, params.leanR_p_h - freeSpace, -params.leanR_p_w / 2 - freeSpace * 2],
            [params.p_w / 2 + parseInt(params.add_storage_right) + freeSpace, 0.15, -params.leanR_p_w / 2 - freeSpace * 2],
        ]
    ), [params.p_w, params.leanR_p_w, params.leanR_p_h, params.add_storage_right])

    const frontTopPoints = useMemo(() => (
        [
            [params.p_w / 2 - freeSpace, params.leanR_p_h - freeSpace, params.leanR_p_w / 2 + freeSpace],
            [params.p_w / 2 + parseInt(params.add_storage_right) - freeSpace, params.leanR_p_h - freeSpace, params.leanR_p_w / 2 + freeSpace],
        ]
    ), [params.p_w, params.leanR_p_w, params.leanR_p_h, params.add_storage_right])

    const frontBottomPoints = useMemo(() => (
        [
            [params.p_w / 2 - freeSpace, 0.15, params.leanR_p_w / 2 + freeSpace],
            [params.p_w / 2 + parseInt(params.add_storage_right) - freeSpace, 0.15, params.leanR_p_w / 2 + freeSpace],
        ]
    ), [params.p_w, params.leanR_p_w, params.add_storage_right])

    const backTopPoints = useMemo(() => (
        [
            [params.p_w / 2 - freeSpace, params.leanR_p_h - freeSpace, -params.leanR_p_w / 2 - freeSpace * 2],
            [params.p_w / 2 + parseInt(params.add_storage_right) - freeSpace, params.leanR_p_h - freeSpace, -params.leanR_p_w / 2 - freeSpace * 2],
        ]
    ), [params.p_w, params.leanR_p_w, params.leanR_p_h, params.add_storage_right])

    const backBottomPoints = useMemo(() => (
        [
            [params.p_w / 2 - freeSpace, 0.15, -params.leanR_p_w / 2 - freeSpace * 2],
            [params.p_w / 2 + parseInt(params.add_storage_right) - freeSpace, 0.15, -params.leanR_p_w / 2 - freeSpace * 2],
        ]
    ), [params.p_w, params.leanR_p_w, params.add_storage_right])

    const renderLine = (points) => (
        <Line
            points={points}
            color="#00BE00"
            lineWidth={3}
            dashSize={0.3}
            gapSize={0.1}
            dashed
        />
    );

    return (
        <group position={[0, 0, 0.1]}>
            {renderLine(leftLinePoints)}
            {renderLine(rightLinePoints)}
            {renderLine(frontTopPoints)}
            {renderLine(frontBottomPoints)}
            {renderLine(backTopPoints)}
            {renderLine(backBottomPoints)}

            <Html position={[params.p_w / 2 + parseInt(params.add_storage_right) / 2, params.leanR_p_h, offset * params.leanR_p_w / 2]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </group>
    )
}

export default OutLineSection